import { render } from "./PicoG3.vue?vue&type=template&id=546427a7&ts=true"
import script from "./PicoG3.ts?vue&type=script&lang=ts&external"
export * from "./PicoG3.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__